<div class="modal-body py-4">
  <div class="w-100 text-center">
    <span class="icon-modal_success"></span>
  </div>
  <div class="row justify-content-center">
    <div class="text-center my-2">
      <h3 class="text-center my-2 fw-bold" [innerHtml]="title"></h3>
      <p [innerHtml]="message"></p>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-8">
      <button class="btn btn-primary w-100" type="button" (click)="dismiss()">
        {{ btnText }}
      </button>
    </div>
  </div>
</div>
